<template>
  <fieldset class="hrr-reason-group">
    <legend class="hrr-reason-group__label">
      {{ group.label }}
    </legend>
    <div class="hrr-reason-group__options">
      <div
        v-for="option in group.options"
        :key="option.key"
        class="hrr-reason-group__option"
        :class="{ 'hrr-reason-group__option--selected': selectedKeys.includes(option.key) }"
      >
        <v-checkbox
          :model-value="selectedKeys.includes(option.key)"
          :label="option.label"
          :disabled="disabled"
          density="compact"
          hide-details
          color="#c8384f"
          @update:model-value="(value: boolean | null) => emit('toggle', option.key, value === true)"
        />
        <InfoTooltip
          v-if="option.description"
          :text="option.description"
          :label="`${option.label}の説明`"
        />
      </div>
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import type { HighRiskReportReasonGroup } from "@/vue/entities/high-risk-report";
import InfoTooltip from "@/vue/shared/ui/InfoTooltip.vue";

defineProps<{
  group: HighRiskReportReasonGroup;
  selectedKeys: number[];
  disabled: boolean;
}>();

const emit = defineEmits<{
  // [reason_key, 選択されたか]
  toggle: [number, boolean];
}>();
</script>

<style lang="scss" scoped>
// 分類見出しは選択対象ではないため、チェックボックスを持たせない（DR-002）。
.hrr-reason-group {
  border: none;
  margin: 0;
  padding: 0;

  & + & {
    margin-top: 10px;
  }
}

.hrr-reason-group__label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 4px;
  padding: 0;
}

// 選択肢は2列。行内の高さを揃えるため stretch のままにする（ラベルは折り返す）。
.hrr-reason-group__options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.hrr-reason-group__option {
  align-items: center;
  background-color: #fff;
  border: 1px solid #ecc9d2;
  border-radius: 6px;
  display: flex;
  gap: 4px;
  padding: 2px 10px;
}

.hrr-reason-group__option--selected {
  border-color: #c8384f;
}

// 選択肢のラベルは長いものがあるため折り返す（v-checkbox の既定は1行）。
.hrr-reason-group__option :deep(.v-label) {
  font-size: 13px;
  line-height: 1.35;
  opacity: 1;
  white-space: normal;
}

// 縦スクロールを避けるため、チェックボックスの既定の行高を詰める。
.hrr-reason-group__option :deep(.v-selection-control) {
  min-height: 32px;
}
</style>
